import { render, staticRenderFns } from "./ModalPixKeyInvalid.vue?vue&type=template&id=e58935ea&"
import script from "./ModalPixKeyInvalid.vue?vue&type=script&lang=js&"
export * from "./ModalPixKeyInvalid.vue?vue&type=script&lang=js&"
import style0 from "./ModalPixKeyInvalid.vue?vue&type=style&index=0&id=e58935ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports